const fromFractionToPercentage = (value) => value * 100;

export default fromFractionToPercentage;
